import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { DropdownOption } from '../types';
import { withTranslation } from 'react-i18next';

class Filter extends React.Component {
  handleAccountsChange = (_, { value }) => {
    this.props.changeReportAccounts(value);
  };

  handleTagsChange = (_, { value }) => {
    this.props.changeReportExcludedTags(value);
  };

  render() {
    const { t } = this.props;

    return (
      <div className="container-footer">
        <Dropdown
          multiple
          selection
          fluid
          placeholder={t('reports.placeholder_specify_accounts')}
          value={this.props.accounts}
          options={this.props.accountOptions}
          onChange={this.handleAccountsChange}
        />
        <Dropdown
          multiple
          selection
          fluid
          search
          placeholder={t('reports.placeholder_exclude_categories')}
          value={this.props.excludeTags}
          options={this.props.tagsOptions}
          onChange={this.handleTagsChange}
        />
      </div>
    );
  }
}

Filter.propTypes = {
  accounts: PropTypes.array,
  accountOptions: PropTypes.array,
  changeReportAccounts: PropTypes.func,
  excludeTags: PropTypes.arrayOf(PropTypes.string),
  tagsOptions: PropTypes.arrayOf(DropdownOption),
  changeReportExcludedTags: PropTypes.func
};

export default withTranslation() (Filter);
